var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiutrndonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1938 10.5V11.3077H15.3477C15.4955 11.0471 15.6116 10.7736 15.7172 10.5H20.1938Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.191 8.07812V8.88582H15.3444C15.5168 8.62527 14.8451 8.3517 14.9683 8.07812H20.191Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3834 5.65234V6.46004H13.4045C13.6172 6.19949 12.7886 5.92592 12.9406 5.65234H19.3834Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7739 3.23047V4.03816H10.501C10.7403 3.77761 10.3548 3.50404 10.5257 3.23047H17.7739Z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3852 15.3438L18.9814 16.1514H14.5527C14.7117 15.8909 14.4556 15.6173 14.5692 15.3438H19.3852Z",
    fill: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1929 12.9219V13.7296H14.5391C14.7115 13.469 14.847 13.1955 14.9702 12.9219H20.1929Z",
    fill: "#383838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#383838"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5015,
    cy: 10.5015,
    r: 5.15385,
    stroke: "#383838"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.402344V5.2485M13.7308 14.537L16.9615 18.5754",
    stroke: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiutrndonut);
export default __webpack_public_path__ + "static/media/biểu đồ tròn donut.979e48abb84e4eec3f7c771b05aefa38.svg";
export { ForwardRef as ReactComponent };